import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2398ca2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = {
  class: "list-container",
  ref: "list"
}
const _hoisted_7 = ["href", "onClick", "data-test"]
const _hoisted_8 = { class: "team-image-container" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "team-name" }

import { ref, computed } from "vue";
import { Modal } from "uiv";

import { TeamApiModel } from "../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-picker-dialog',
  props: {
    teams: {},
    canCreateTeams: { type: Boolean },
    selection: { default: null },
    navigateOnClick: { type: Boolean, default: true }
  },
  emits: ["selection-changed"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;

const shown = ref(false);

const title = computed(() =>
  props.canCreateTeams ? "Pick a different team:" : "Pick a different team:",
);

function open(): void {
  shown.value = true;
}

function close(): void {
  shown.value = false;
}

function cancel(): void {
  close();
}

function handleTeamClick(teamSelected: TeamApiModel): void {
  emit("selection-changed", teamSelected);
}

function getTeamHomeUrl(team: TeamApiModel): string {
  // eslint-disable-next-line no-script-url
  return props.navigateOnClick ? `/home?view=TeamDashboard&team=${team.id}` : "javascript:void(0)";
}

__expose({
  open,
  cancel,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    class: "team-picker-dialog text-left",
    modelValue: shown.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shown).value = $event)),
    title: title.value,
    footer: false,
    "append-to-body": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team, index) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: team.id,
                      class: _normalizeClass(["list-item a-no-highlight", { selected: team === _ctx.selection }]),
                      href: getTeamHomeUrl(team),
                      onClick: ($event: any) => (handleTeamClick(team)),
                      "data-test": `team-link-${index}`
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: team.imageUrl,
                          class: "team-image team-image-border",
                          alt: "team image"
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(team.name), 1)
                    ], 10, _hoisted_7))
                  }), 128))
                ], 512)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})